import { useMutation, useQueryClient } from 'react-query';
import { deleteData, MutationKeyConfig, QueryKeyConfig } from '../api/api-helper';
import { useSnackbar } from './use-snackbar.hook';

export type InvalidateRoute = (data: any) => QueryKeyConfig;

export const useDeleteData = <T>(config: MutationKeyConfig, invalidateRoute?: InvalidateRoute) => {
  const { showSnackbar } = useSnackbar();
  const client = useQueryClient();
  return useMutation({
    mutationKey: config.mutationKey,
    mutationFn: () => deleteData<T>(config.route),
    onSuccess: ({ data }: any) => {
      if (!config.disableSnackbar) {
        showSnackbar('Deleted successfully', 'success');
      }
      if (invalidateRoute) {
        client.invalidateQueries(invalidateRoute(data).queryKey);
      }
    },
    onError: (data: any) => {
      if (data?.response?.data?.message) {
        showSnackbar(data?.response?.data?.message, 'error');
      } else {
        showSnackbar('Failed to delete data', 'error');
      }
    },
  });
};
